var _excluded = ["attrs", "classes", "size", "src"],
  _excluded2 = ["width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { number, shape, string } from 'prop-types';
import { mergeClasses } from '../../classify';
import defaultClasses from './icon.css';
var Icon = props => {
  // destructure `propClasses` to exclude it from `restProps`
  var {
      attrs,
      classes: propClasses,
      size,
      src: Component
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  var _ref = attrs || {},
    {
      width
    } = _ref,
    restAttrs = _objectWithoutProperties(_ref, _excluded2);
  var classes = mergeClasses(defaultClasses, propClasses);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classes.root
  }, restProps), /*#__PURE__*/React.createElement(Component, _extends({
    className: classes.icon,
    size: size || width
  }, restAttrs)));
};
export default Icon;
Icon.propTypes = {
  attrs: shape({}),
  classes: shape({
    icon: string,
    root: string
  }),
  size: number
};